import { createAsyncThunk } from '@reduxjs/toolkit';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../../firebaseConfig';
import { updateUserProfileRealtime, setRealtimeError } from '../slice.js';

// Real-time subscription thunk
export const subscribeToUserProfile = createAsyncThunk(
  'profile/subscribeToUserProfile',
  async (userId, { dispatch, rejectWithValue }) => {
    try {
      if (!userId) {
        throw new Error('User ID is required for subscription');
      }

      const userDocRef = doc(db, 'users', userId);

      // Return the unsubscribe function
      const unsubscribe = onSnapshot(
        userDocRef,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            const userData = { id: docSnapshot.id, ...docSnapshot.data() };
            // Dispatch real-time update
            dispatch(updateUserProfileRealtime(userData));
          } else {
            console.warn(`User document ${userId} does not exist`);
          }
        },
        (error) => {
          console.error('Real-time subscription error:', error);
          dispatch(setRealtimeError(error.message));
        }
      );

      return { unsubscribe, userId };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
